import React from 'react';

const Service = () => {
    return (
        <div class="pservice">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="pservice__items d-flex">
              <div class="pservice-item">
                <div class="pservice__title">
                  О Сервисе
                </div>
                <div class="pservice__subtitle">
                  Redslon.ru — это биржа групп в социальных сетях. Наш сервис
                  позволяет быстро и безопасно купить или продать группу
                  Вконтакте, Одноклассниках и Фейсбуке, а также странички
                  Instagram и д.р.
                </div>
                <div class="pservice__cont">
                  Приоритетные задачи для нас, это продвижение рынка покупки и
                  продажи сообществ. Мы стремимся сделать этот процесс
                  максимально удобным, быстрым и безопасным для пользователей.
                </div>
                <div class="pservice__cont">
                  До сих пор основными площадками для продажи групп Вконтакте и
                  Одноклассниках были форумы, где покупатели и продавцы
                  договаривались о сделках, часто пренебрегая важными
                  формальностями, в результате чего развивалось мошенничество в
                  данной сфере. Команда<span> Salegroups.ru</span> ежедневно
                  работает над разработкой интерфейса для комфортного
                  использования обеими сторонами, а также для автоматизации
                  процесса и максимально возможного исключения человеческого
                  фактора в процессе сделки.
                </div>
                <div class="pservice__cont">
                  Создатели сервиса Redslon сами являются администраторами
                  сообществ в социальных сетях и о покупке и продаже групп знают
                  не по наслышке, что отражено в ответственном подходе к
                  разработке сервиса.
                </div>
                <div class="pservice__cont">
                  Успешных Вам сделок!
                </div>
                <div class="pservice__cont">
                  С уважением, команда Redslon.ru
                </div>
              </div>
              <div class="pservice-item2">
                <div class="item2__title">
                  Хотите купить группу?
                </div>
                <div class="item2-text">
                  Найти подходящее сообщество для покупки Вы можете благодаря
                  удобному фильтру по основным параметрам, а подробная
                  информация о состоянии группы (цена, численность, способы
                  продвижения, контент и пр.) позволит быстро принять верное
                  решение.
                </div>
                <div class="item2__icons">
                  <div class="price-search__item search-item d-flex ml-auto">
                    <div class="sm__item psi1">
                      <a href="#"><i class="fas fa-globe"></i></a>
                    </div>
                    <div class="sm__item psi2">
                      <a href="#"><i class="fab fa-tiktok"></i></a>
                    </div>
                    <div class="sm__item psi3">
                      <a href="#"><i class="fab fa-youtube"></i></a>
                    </div>
                    <div class="sm__item psi4">
                      <a href="#"><i class="fab fa-vk"></i></a>
                    </div>
                    <div class="sm__item psi5">
                      <a href="#"><i class="fab fa-instagram"></i></a>
                    </div>
                    <div class="sm__item psi6">
                      <a href="#"><i class="fab fa-facebook-f"></i> </a>
                    </div>
                    <div class="sm__item psi7">
                      <a href="#"><i class="fab fa-odnoklassniki"></i></a>
                    </div>
                    <div class="sm__item psi8">
                      <a href="#"><i class="fab fa-telegram-plane"></i></a>
                    </div>
                  </div>
                </div>
                <div class="item2__title">
                  Хотите продать группу?
                </div>
                <div class="item2__text">
                  Добавить новое объявление о продаже сообщества Вы можете за
                  несколько простых движений, а регулярный рост аудитории
                  сервиса Redslon.ru не заставит долго ждать покупателя. Важно:
                  чем полнее Вы укажете информацию о продаваемом сообществе, тем
                  быстрее потенциальный покупатель примет решение о покупке.
                </div>
                <div class="item2__icon">
                  <a href="#"
                    >Новое объявление
                    <div class="itemw-icon__docs">
                      <img src="img/docs.png" alt="img" />
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    );
}

export default Service;
